import React, { useEffect, useState, useContext, useRef, useMemo, useCallback } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Progress, Grid, Table, Button as NextButton, Card as NextCard, Text, Avatar } from "@nextui-org/react";
import { Message } from 'primereact/message';

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import { formatDecimals, formatCurrencyExtended, formatWalletAddress, getTokenPrice, getTokenDecimals, formatTokenIcon, formatPercentage } from '../../utils';
import { miniInfoStyle, cardStyle, infoOutlineStyle, cardHeaderStyle, miniCardHeaderStyle, cardHeaderInvertStyle, cardOutlineStyle } from "./TileStyles";

import { getGradientCardStyle } from "./TileStyles";
import rocketfiIcon from "../../imgs/rocketfi_yellow_token.png";
import BigNumber from 'bignumber.js'

import { InputText } from 'primereact/inputtext';

import {
  LineChart, Line, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList
} from 'recharts';

import smartCodesAbi from "../../contracts/smartCodesAbi";

const DashboardSmartCode = ({ data, getData, rocketFiPrice }) => {

  //states
  const { library, account } = useWeb3React();
  const contractContext = useContext(ContractContext);
  const contracts = contractContext.contracts;
  const isWalletConnected = useCallback(() => account !== null, [account]);

  const [smartCode, setSmartCode] = useState("");
  const [smartCodeData, setSmartCodeData] = useState({});
  const [rocketFiLoyaltyPoints, setRocketFiLoyaltyPoints] = useState();
  const [cumulativeLoyaltyPoints, setCumulativeLoyaltyPoints] = useState();
  const [rocketFiRewardsData, setRocketFiRewardsData] = useState();
  const [pendingRewards, setPendingRewards] = useState();
  const [smartCodeSwapper, setSmartCodeSwapper] = useState();
  const [loyaltyEngineData, setLoyaltyEngineData] = useState();
  const [earningsData, setEarningsData] = useState();
  const [earningsSharedData, setEarningsSharedData] = useState();
  const [isRegistered, setIsRegistered] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [smartCodeEvents, setSmartCodeEvents] = useState([]);
  const [smartCodeCreationEvents, setSmartCodeCreationEvents] = useState([]);
  const [selectedTimeRange, setSelectedTimeRange] = useState("7d"); 
  //refs
  const smartCodeInputRef = useRef(null);
  const toast = useRef(null);



  //styles
  const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
  const LoadingChart = () => <Skeleton width="80%" height="150px" className="mb-2" />;


  //functions
  async function GetLatestBlockNumber() {
    if (!library || !contracts.rocketFi) return;
    const web3 = new Web3(library.provider);
    const currentBlock = await web3.eth.getBlock("latest");
    return currentBlock.number
  }

  // Assuming an average block time of ~3 seconds for Binance Smart Chain
  const BLOCK_TIME_IN_SECONDS = 3;
  const BLOCKS_PER_DAY = 24 * 60 * 60 / BLOCK_TIME_IN_SECONDS;

  let totalBlocksToFetch = 15000000;

  const getTimeRangeStartingBlock = async (timeRange) => {
    const currentBlock = await GetLatestBlockNumber();
    let blocksToGoBack;

    switch (timeRange) {
      case '7d':
        blocksToGoBack = 7 * BLOCKS_PER_DAY;
        break;
      case '30d':
        blocksToGoBack = 30 * BLOCKS_PER_DAY;
        break;
      case '45d':
        blocksToGoBack = 45 * BLOCKS_PER_DAY;
        break;
      case '3m':
        blocksToGoBack = 90 * BLOCKS_PER_DAY; // 3 months
        break;
      case '6m':
        blocksToGoBack = 180 * BLOCKS_PER_DAY; // 6 months
        break;
      case '9m':
        blocksToGoBack = 270 * BLOCKS_PER_DAY; // 9 months
        break;
      case '1y':
        blocksToGoBack = 365 * BLOCKS_PER_DAY; // 1 year
        break;
      case 'all':
        blocksToGoBack = totalBlocksToFetch; // Assuming totalBlocksToFetch is defined globally
        break;
      default:
        blocksToGoBack = 7 * BLOCKS_PER_DAY; // Default case
    }

    return Math.max(currentBlock - blocksToGoBack, 0);
  };

  useEffect(() => {
    // Function to fetch events based on the selected time range
    const fetchEventsBasedOnTimeRange = async () => {
      await GetPastSmartCodeEvents(); // Ensure this function uses the selectedTimeRange to determine blocks range
    };
  
    // Call the function to fetch data
    fetchEventsBasedOnTimeRange();
  }, [selectedTimeRange, contracts.smartCodes, data]); // Add selectedTimeRange as a dependency
  
//   async function GetPastSmartCodeEvents() {
//     if (!library || !contracts?.smartCodes) return;

//     const web3 = new Web3("https://binance.llamarpc.com/sk_llama_e2e9915b5438c5313ae3d634858d85cb");
//     const abi = smartCodesAbi;
//     const contract_address = contracts.smartCodes._address;
//     const contract = new web3.eth.Contract(abi, contract_address);

//     const maxBlocks = 200000; // Maximum number of blocks per chunk to handle large ranges efficiently

//     let currentBlock = await GetLatestBlockNumber();
//     let fromBlock = await getTimeRangeStartingBlock(selectedTimeRange);

//     let promisesSwapSummary = [];
//     let promisesReferralRegistered = [];

//     let blocksToFetch = currentBlock - fromBlock;
//     let totalChunks = Math.ceil(blocksToFetch / maxBlocks);

//     // Reset loading progress
//     //setLoadingProgress(0);

//     // Fetch events in chunks
//     for (let offset = 0; offset < blocksToFetch; offset += maxBlocks) {
//         let chunkFromBlock = Math.max(fromBlock + offset, 0);
//         let chunkToBlock = Math.min(fromBlock + offset + maxBlocks, currentBlock);

//         // Add promises for each chunk to the arrays for SwapSummary and ReferralRegistered events
//         promisesSwapSummary.push(contract.getPastEvents('SwapSummary', { fromBlock: chunkFromBlock, toBlock: chunkToBlock }));
//         promisesReferralRegistered.push(contract.getPastEvents('ReferralRegistered', { fromBlock: chunkFromBlock, toBlock: chunkToBlock }));
//     }

//     try {
//         // Wait for all promises to resolve for both event types and update progress
//         let eventsArraySwapSummary = await Promise.all(promisesSwapSummary.map((p, index) => p.then(result => {
//             // Update progress for each chunk
//             //setLoadingProgress(prevProgress => prevProgress + (100 / totalChunks));
//             return result;
//         })));

//         let eventsArrayReferralRegistered = await Promise.all(promisesReferralRegistered.map((p, index) => p.then(result => {
//             // Optionally update progress here as well, if needed
//             return result;
//         })));

//         // Process and sort events
//         let allSwapSummaryEvents = eventsArraySwapSummary.flat().sort((a, b) => a.blockNumber - b.blockNumber);
//         let allReferralRegisteredEvents = eventsArrayReferralRegistered.flat().sort((a, b) => a.blockNumber - b.blockNumber);

//         // Update state with events
//         setSmartCodeEvents(allSwapSummaryEvents);
//         localStorage.setItem('rocketfi_smartCodeEvents', JSON.stringify(allSwapSummaryEvents));
//         setSmartCodeCreationEvents(allReferralRegisteredEvents);
//         localStorage.setItem('rocketfi_smartCodeCreationEvents', JSON.stringify(allReferralRegisteredEvents));

//         // Reset loading state
//         //setIsLoading(false);
//     } catch (error) {
//         console.error("Error fetching events:", error);
//         //setIsLoading(false);
//     }
// }

  async function GetPastSmartCodeEvents() {
    if (!library || !contracts?.smartCodes) return;

    const web3 = new Web3("https://binance.llamarpc.com/sk_llama_e2e9915b5438c5313ae3d634858d85cb");
    const abi = smartCodesAbi;
    const contract_address = contracts.smartCodes._address;
    const contract = new web3.eth.Contract(abi, contract_address);

    const maxBlocks = 10000; // Maximum number of blocks per chunk

    let currentBlock = await GetLatestBlockNumber();
    let fromBlock = await getTimeRangeStartingBlock(selectedTimeRange);

    let promisesSwapSummary = [];
    let promisesReferralRegistered = [];

    let blocksToFetch = Math.min(currentBlock - fromBlock);

    // Split the total blocks into chunks and fetch each chunk concurrently
    for (let offset = 0; offset < blocksToFetch; offset += maxBlocks) {
      let chunkFromBlock = Math.max(fromBlock + offset, 0);
      let chunkToBlock = Math.min(fromBlock + offset + maxBlocks, currentBlock);

      // Add a promise for each chunk to the promises array for both events
      promisesSwapSummary.push(contract.getPastEvents('SwapSummary', { fromBlock: chunkFromBlock, toBlock: chunkToBlock }));
      promisesReferralRegistered.push(contract.getPastEvents('ReferralRegistered', { fromBlock: chunkFromBlock, toBlock: chunkToBlock }));
    }

    try {
      // Wait for all promises to resolve for both event types
      let eventsArraySwapSummary = await Promise.all(promisesSwapSummary);
      let eventsArrayReferralRegistered = await Promise.all(promisesReferralRegistered);

      // Merge, sort, and update state for SwapSummary events
      let allSwapSummaryEvents = [].concat.apply([], eventsArraySwapSummary);
      allSwapSummaryEvents.sort((a, b) => a.blockNumber - b.blockNumber);
      setSmartCodeEvents(allSwapSummaryEvents);
      localStorage.setItem('rocketfi_smartCodeEvents', JSON.stringify(allSwapSummaryEvents));

      // Merge, sort, and update state for ReferralRegistered events
      let allReferralRegisteredEvents = [].concat.apply([], eventsArrayReferralRegistered);
      allReferralRegisteredEvents.sort((a, b) => a.blockNumber - b.blockNumber);
      setSmartCodeCreationEvents(allReferralRegisteredEvents);
      localStorage.setItem('rocketfi_smartCodeCreationEvents', JSON.stringify(allReferralRegisteredEvents));

      //console.log("SwapSummary Events:", allSwapSummaryEvents);
      //console.log("ReferralRegistered Events:", allReferralRegisteredEvents);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  }




  useEffect(() => {
    const storedSmartCodeEvents = localStorage.getItem('rocketfi_smartCodeEvents');
    if (storedSmartCodeEvents) {
      setSmartCodeEvents(JSON.parse(storedSmartCodeEvents));
    }

    const storedSmartCodeCreationEvents = localStorage.getItem('rocketfi_smartCodeCreationEvents');
    if (storedSmartCodeCreationEvents) {
      setSmartCodeCreationEvents(JSON.parse(storedSmartCodeCreationEvents));
    }

    // Fetch the latest smartCode events
    GetPastSmartCodeEvents();

  }, [contracts.smartCodes, data]);


  const [swapSmartCodes, setSwapSmartCodes] = useState([]);
  const [referralSmartCodes, setReferralSmartCodes] = useState([]);
  const [smartCodeCreationEventsWithTimestamps, setSmartCodeCreationEventsWithTimestamps] = useState([]);
  const [smartCodeReferralEventsWithTimestamps, setSmartCodeReferralEventsWithTimestamps] = useState([]);
  const [smartCodeSwapEventsWithTimestamps, setSmartCodeSwapEventsWithTimestamps] = useState([]);

  useEffect(() => {
    if (!smartCodeSwapEventsWithTimestamps) return;
    if (!contracts.smartCodes) return;

    let uniqueAddresses = [];
    //console.log("smartCodeSwapEventsWithTimestamps:", smartCodeSwapEventsWithTimestamps);
    smartCodeSwapEventsWithTimestamps.forEach((event) => {
      if (!uniqueAddresses.includes(event.returnValues.buyer)) {
        uniqueAddresses.push(event.returnValues.buyer);
      }
    });
    //console.log("uniqueAddresses:", uniqueAddresses);
    // Use Promise.all to wait for all asynchronous calls to complete before setting the state
    const fetchSmartCodes = async () => {
      let _smartCodeData = {};
      await Promise.all(uniqueAddresses.map(async (address) => {
        const data = await getSmartCodeDataUser(address);
        _smartCodeData[address] = data;
      }));
      setSwapSmartCodes(_smartCodeData);
    };

    fetchSmartCodes();
  }, [smartCodeSwapEventsWithTimestamps, contracts.smartCodes]);

  useEffect(() => {
    if (!smartCodeReferralEventsWithTimestamps) return;
    if (!contracts.smartCodes) return;

    let uniqueAddresses = [];
    //console.log("smartCodeReferralEventsWithTimestamps:", smartCodeReferralEventsWithTimestamps);
    smartCodeReferralEventsWithTimestamps.forEach((event) => {
      if (!uniqueAddresses.includes(event.returnValues.buyer)) {
        uniqueAddresses.push(event.returnValues.buyer);
      }
    });
    //console.log("uniqueAddresses:", uniqueAddresses);
    // Use Promise.all to wait for all asynchronous calls to complete before setting the state
    const fetchSmartCodes = async () => {
      let _smartCodeData = {};
      await Promise.all(uniqueAddresses.map(async (address) => {
        const data = await getSmartCodeDataUser(address);
        _smartCodeData[address] = data;
      }));
      setReferralSmartCodes(_smartCodeData);
    };

    fetchSmartCodes();
  }, [smartCodeReferralEventsWithTimestamps, contracts.smartCodes]);

  useEffect(() => {
    //console.log("smartCodeData:", smartCodeData);
  }, [smartCodeData]);


  async function getBlockTimestamp(blockNumber) {
    if (!library) return;
    const web3 = new Web3(library.provider);
    const block = await web3.eth.getBlock(blockNumber);
    return block.timestamp;
  }

  async function fetchTimestampsForEvents(events) {
    const promises = events.map(event => getBlockTimestamp(event.blockNumber));
    const timestamps = await Promise.all(promises);
    return events.map((event, index) => ({
      ...event,
      timestamp: timestamps[index]
    }));
  }


  useEffect(() => {
    fetchTimestampsForEvents(smartCodeCreationEvents).then(setSmartCodeCreationEventsWithTimestamps);
  }, [smartCodeCreationEvents]);





  useEffect(() => {
    const referralEvents = smartCodeEvents?.filter((event) => event.returnValues.smartCodeOwner.toLowerCase() === account.toLowerCase())
      .sort((a, b) => b.blockNumber - a.blockNumber)
      .slice(0, 10);
    fetchTimestampsForEvents(referralEvents).then(setSmartCodeReferralEventsWithTimestamps);
  }, [smartCodeEvents]);



  useEffect(() => {
    const swapEvents = smartCodeEvents
      .sort((a, b) => b.blockNumber - a.blockNumber)
      .slice(0, 50);
    fetchTimestampsForEvents(swapEvents).then(setSmartCodeSwapEventsWithTimestamps);
  }, [smartCodeEvents]);



  const checkSmartCode = async (code) => {
    if (!code) {
      setFeedback("");
      setIsRegistered(false);
      return;
    }

    let isReg = false;
    try {
      //if (await inMigration()) {
      isReg = await getIsRegisteredFull(code);
      //} else {
      //    isReg = await getIsRegistered(code);
      //}
    } catch (error) {
      console.error("Error checking smart code:", error);
    }

    setIsRegistered(isReg);
    setFeedback(isReg ? "Smart Code is already registered." : "Smart Code is available 🎉");
  }
  const debouncedCheckSmartCode = debounce(checkSmartCode, 1750);

  const handleSmartCodeInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    setSmartCode(value);
    debouncedCheckSmartCode(value);
  }



  const saveEarningsDataToLocal = (newData, key) => {
    if (!isWalletConnected() || !newData) return;
    const storedData = localStorage.getItem(key);

    try {
      const parsedData = JSON.parse(storedData || "[]"); // Default to an empty array if there's no data

      // If no storedData exists or newData is more recent, overwrite the old data.
      if (!storedData || (newData[0]?.timestamp >= parsedData[0]?.timestamp)) {
        localStorage.setItem(key, JSON.stringify(newData));
      }
    } catch (error) {
      console.error("Error parsing local storage data:", error);
      // Optionally reset corrupted storage
      localStorage.setItem(key, JSON.stringify(newData));
    }
  };


  const earningsDataFromLocalStorage = useMemo(() => {
    const storedData = localStorage.getItem(`earningsData-${account}`);
    return storedData && storedData !== "undefined" ? JSON.parse(storedData) : null;
  }, [account]);

  const earningsSharedDataFromLocalStorage = useMemo(() => {
    const storedData = localStorage.getItem(`earningsSharedData-${account}`);
    return storedData && storedData !== "undefined" ? JSON.parse(storedData) : null;
  }, [account]);

  useEffect(() => {
    if (!isWalletConnected()) return;

    if (earningsDataFromLocalStorage) {
      setEarningsData(earningsDataFromLocalStorage);
    }
    if (earningsSharedDataFromLocalStorage) {
      setEarningsSharedData(earningsSharedDataFromLocalStorage);
    }
  }, [earningsDataFromLocalStorage, earningsSharedDataFromLocalStorage]);


  //function renders

  const CreateSmartCodeComponent = React.memo(() => {
    return (
      <div style={cardHeaderStyle}>
        <br />
        Interact with crypto safely by removing the complicated guess work.
        Smart Codes are used to send crypto, get discounts, and earn rewards through referrals<br /><br />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', marginTop: '10px' }}>
          <InputText
            ref={smartCodeInputRef}
            placeholder="Enter Smart Code"
            value={smartCode}
            onChange={handleSmartCodeInputChange}
          />

          <Button
            label="Create Smart Code"
            disabled={isRegistered || !smartCode}
            rounded
            severity="primary"
            size="small"
            style={{ width: '100%', justifyContent: 'center' }}
            onClick={() => handleCreateSmartCode(smartCode)}
          />
          <div>
            {feedback}
          </div>
        </div>
      </div>
    );
  });

  const MigrateSmartCodeComponent = React.memo(() => {
    return (
      <>

        {<div style={cardHeaderStyle}>
          <br />
          Please migrate your smart code {data.contractData.forgeData.referralCode} to the new contract. <br />
          You will have the option to change Smart Codes after the migration period has been disabled.<br /><br />

          <Button
            label="Migrate Smart Code"
            onClick={() => handleMigrateSmartCode()}
            rounded
            severity="primary"
            size="small"
            style={{ width: '100%', justifyContent: 'center' }}
          />
        </div>}


      </>
    );
  });


  const SmartCodeLoyaltyProgressComponent = React.memo(() => {
    return (
      < div
        style={{
          padding: '10px',
        }}>

        <Grid.Container gap={4} style={{
          //code to align everthing centered vertically and horizontally
          display: 'space-between',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}>
          <Grid>
            <div style={{ marginTop: '1px' }}>

              <Avatar text={rocketFiLoyaltyPoints} size="xl" color="gradient" textColor="white" /><br />
              RocketFi+<br />
              Points
            </div>
          </Grid>
          <Grid>
            <div style={{ marginTop: '1px' }}>

              <Avatar text={formatPercentage(parseInt(rocketFiLoyaltyPoints) / parseInt(cumulativeLoyaltyPoints))} size="xl" color="gradient" textColor="white" /><br />
              Reward<br />
              Position
            </div>
          </Grid>
        </Grid.Container>

        {rocketFiRewardsData && rocketFiLoyaltyPoints > 0 && (!rocketFiRewardsData?.isExistingUser || rocketFiRewardsData?.shares === 0 || parseFloat(rocketFiLoyaltyPoints) > parseFloat(rocketFiRewardsData?.shares)) &&
          <div style={cardHeaderStyle}>
            <div style={{ marginTop: '15px', marginBottom: '10px' }}>
              <Message severity="info" text={parseFloat(rocketFiLoyaltyPoints) > parseFloat(rocketFiRewardsData?.shares) ? "Resync your updated position to maximize your rewards" : "A Resync is required to earn rewards during Smart Code Referral swaps"} />
            </div>
            <Button
              label="Sync RocketFi+ Points"
              onClick={() => handleResyncPoints()}
              rounded
              severity="primary"
              size="small"
              style={{ width: '100%', justifyContent: 'center', marginBottom: '15px' }}
            />

          </div>

        }
        {//rocketFiLoyaltyPoints > 0 && rocketFiRewardsData?.shares === rocketFiLoyaltyPoints &&
          <>
            {//rocketFiLoyaltyPoints === 0 &&
              parseInt(rocketFiLoyaltyPoints) === 0 &&
              (roundDownBig(new BigNumber(data?.contractData?.tokenData?.rocketFiBalance).div(new BigNumber(loyaltyEngineData?.WALLET_MULTIPLIER))) * loyaltyEngineData?.w6 > 0 ||
                roundDownBig(new BigNumber(data?.contractData?.burnData?.burnedAmount).div(new BigNumber(loyaltyEngineData?.BURN_MULTIPLIER))) * loyaltyEngineData?.w5 > 0) &&
              <div style={{ marginTop: '15px' }}>
                <Message severity="info" text="To activate your RocketFi+ Points, you need at least 1 referral swap" />
              </div>
            }


          </>
        }

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(250px, 100%), 1fr))',
          gap: '10px',
          marginTop: '10px',
          marginBottom: '10px',
        }}>

          <div
            style={{
              borderRadius: '20px',
              background: '#1c1c1c',
              padding: '15px',
            }}>
            <div style={{ marginTop: '1px' }}>
              RocketFi Held
              <div style={{ marginTop: '5px' }}>
                <Progress color="gradient" size="sm" value={(new BigNumber(data?.contractData?.tokenData?.rocketFiBalance))
                  .div(new BigNumber(loyaltyEngineData?.WALLET_MULTIPLIER))
                  .minus(roundDownBig(new BigNumber(data?.contractData?.tokenData?.rocketFiBalance)
                    .div(new BigNumber(loyaltyEngineData?.WALLET_MULTIPLIER))))
                  .times(100)
                  .toNumber()} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '1px' }}>
              <div>
                <div style={miniCardHeaderStyle}>
                  Total Balance
                </div>
                <div style={miniInfoStyle}>
                  {formatDecimals(data?.contractData?.tokenData?.rocketFiBalance, 9)}
                </div>
              </div>
              <div>
                <div style={miniCardHeaderStyle}>
                  RocketFi+ Points
                </div>
                <div style={miniInfoStyle}>
                  {data?.contractData?.tokenData?.rocketFiBalance && loyaltyEngineData ? roundDownBig(new BigNumber(data?.contractData?.tokenData?.rocketFiBalance).div(new BigNumber(loyaltyEngineData?.WALLET_MULTIPLIER))) * loyaltyEngineData?.w6 : LoadingContent()}
                </div>
              </div>

            </div>
          </div>

          <div
            style={{
              borderRadius: '20px',
              background: '#1c1c1c',
              padding: '15px',
            }}>
            <div style={{ marginTop: '1px' }}>
              RocketFi Burned
              <div style={{ marginTop: '5px' }}>
                <Progress color="gradient" size="sm" value={(new BigNumber(data.contractData?.burnData?.burnedAmount))
                  .div(new BigNumber(loyaltyEngineData?.BURN_MULTIPLIER))
                  .minus(roundDownBig(new BigNumber(data.contractData?.burnData?.burnedAmount)
                    .div(new BigNumber(loyaltyEngineData?.BURN_MULTIPLIER))))
                  .times(100)
                  .toNumber()} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '1px' }}>
              <div>
                <div style={miniCardHeaderStyle}>
                  Total Burned
                </div>
                <div style={miniInfoStyle}>
                  {formatDecimals(data.contractData?.burnData?.burnedAmount, 9)}
                </div>
              </div>
              <div>
                <div style={miniCardHeaderStyle}>
                  RocketFi+ Points
                </div>
                <div style={miniInfoStyle}>
                  {data.contractData?.burnData?.burnedAmount && loyaltyEngineData ? roundDownBig(new BigNumber(data.contractData?.burnData?.burnedAmount).div(new BigNumber(loyaltyEngineData?.BURN_MULTIPLIER))) * loyaltyEngineData?.w5 : LoadingContent()}
                </div>
              </div>

            </div>
          </div>

          <div
            style={{
              borderRadius: '20px',
              background: '#1c1c1c',
              padding: '15px',
            }}>
            <div style={{ marginTop: '1px' }}>
              Referrals
              <div style={{ marginTop: '5px' }}>
                <Progress color="gradient" size="sm" value={
                  (smartCodeData?.stats?.totalReferrals / loyaltyEngineData?.REFERRAL_MULTIPLIER -
                    roundDown(smartCodeData?.stats?.totalReferrals / loyaltyEngineData?.REFERRAL_MULTIPLIER))
                  * 100} />
                {/*<Progress color="success" status="success" size="sm" value={9 / loyaltyEngineData?.REFERRAL_MULTIPLIER * 100} />*/}
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '1px' }}>
              <div>
                <div style={miniCardHeaderStyle}>
                  Total Referrals
                </div>
                <div style={miniInfoStyle}>
                  {smartCodeData?.stats?.totalReferrals}
                </div>


              </div>
              <div>
                <div style={miniCardHeaderStyle}>
                  RocketFi+ Points
                </div>
                <div style={miniInfoStyle}>
                  {smartCodeData?.stats?.totalReferrals && loyaltyEngineData ? roundDown(smartCodeData?.stats?.totalReferrals / loyaltyEngineData?.REFERRAL_MULTIPLIER) * loyaltyEngineData?.w2 : LoadingContent()}
                </div>

              </div>
            </div>


          </div>
          <div
            style={{
              borderRadius: '20px',
              background: '#1c1c1c',
              padding: '15px',
            }}>
            <div style={{ marginTop: '1px' }}>
              Swaps
              <div style={{ marginTop: '5px' }}>
                <Progress color="gradient" size="sm" value={
                  (smartCodeData?.stats?.totalPurchases / loyaltyEngineData?.PURCHASE_MULTIPLIER -
                    roundDown(smartCodeData?.stats?.totalPurchases / loyaltyEngineData?.PURCHASE_MULTIPLIER))
                  * 100} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '1px' }}>
              <div>
                <div style={miniCardHeaderStyle}>
                  Total Swaps
                </div>
                <div style={miniInfoStyle}>
                  {smartCodeData?.stats?.totalPurchases}

                </div>

              </div>
              <div>

                <div style={miniCardHeaderStyle}>
                  RocketFi+ Points
                </div>
                <div style={miniInfoStyle}>
                  {smartCodeData?.stats?.totalPurchases && loyaltyEngineData ? roundDown(smartCodeData?.stats?.totalPurchases / loyaltyEngineData?.PURCHASE_MULTIPLIER) * loyaltyEngineData?.w3 : LoadingContent()}
                </div>
              </div>

            </div>


          </div>
          <div
            style={{
              borderRadius: '20px',
              background: '#1c1c1c',
              padding: '15px',
            }}>
            <div style={{ marginTop: '1px' }}>
              RocketFi Purchased
              <div style={{ marginTop: '5px' }}>
                <Progress color="gradient" size="sm" value={(new BigNumber(smartCodeData?.stats?.amountBought))
                  .div(new BigNumber(loyaltyEngineData?.TOKEN_MULTIPLIER))
                  .minus(roundDownBig(new BigNumber(smartCodeData?.stats?.amountBought)
                    .div(new BigNumber(loyaltyEngineData?.TOKEN_MULTIPLIER))))
                  .times(100)
                  .toNumber()} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '1px' }}>
              <div>
                <div style={miniCardHeaderStyle}>
                  Total Purchased
                </div>
                <div style={miniInfoStyle}>
                  {formatDecimals(smartCodeData?.stats?.amountBought, 9)}
                </div>
              </div>
              <div>
                <div style={miniCardHeaderStyle}>
                  RocketFi+ Points
                </div>
                <div style={miniInfoStyle}>
                  {smartCodeData?.stats?.amountBought && loyaltyEngineData ? roundDownBig(new BigNumber(smartCodeData?.stats?.amountBought).div(new BigNumber(loyaltyEngineData?.TOKEN_MULTIPLIER))) * loyaltyEngineData?.w4 : LoadingContent()}
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    );
  });


  // Assuming you have a variable or state that determines if dark mode is active
  const isDarkMode = true; // Set this to your actual dark mode state

  const darkModeColors = {
    text: '#EAEAEA',          // Light gray for dark backgrounds
    axis: '#888888',         // Some gray color for axis
    background: '#333333',   // Dark background
    bar: '#8884d8',          // Your bar color, you can adjust as needed
    tooltip: '#444444'       // Tooltip background
  };

  const lightModeColors = {
    text: '#333333',
    axis: '#888888',
    background: '#FFFFFF',
    bar: '#8884d8',
    tooltip: '#FFFFFF'
  };

  const colors = isDarkMode ? darkModeColors : lightModeColors;

  const dateTickFormatter = (timestamp) => {
    const dateObject = new Date(timestamp);
    const formattedDate = `${dateObject.getMonth() + 1}/${dateObject.getDate()}/${dateObject.getFullYear()}`;
    return formattedDate;
  }

  const RewardChartComponent = React.memo(() => {

    if ((!earningsData || earningsData.length === 0) && (!earningsSharedData || earningsSharedData.length === 0)) {
      return <></>;
    }


    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(150px, 100%), 1fr))',
          gap: '10px',
          marginTop: '10px',
          marginBottom: '10px'
        }}>
        {earningsData.length > 0 && <Card
          title={
            <div style={{ ...infoOutlineStyle, fontSize: '16px' }}>Your Referral Rewards</div>
          }
          style={cardOutlineStyle}
        >
          {earningsData ? <ResponsiveContainer width="100%" height={pendingRewards > 0 ? 200 : 300}>
            <BarChart
              data={earningsData}
              margin={{
                top: 25, right: 5, left: -15, bottom: 5,
              }}
              background={colors.background}
            >
              <XAxis
                dataKey="date"
                name="Date"
                tickFormatter={dateTickFormatter}
                stroke={colors.text}
                axisLine={{ stroke: colors.axis }}
                tickLine={{ stroke: colors.axis }}
                tick={{ fontSize: 12 }}
              />
              <YAxis
                dataKey="amountUSD"
                name="Rewards"
                tickFormatter={(value) => formatCurrencyExtended(value)}
                stroke={colors.text}
                axisLine={{ stroke: colors.axis }}
                tickLine={{ stroke: colors.axis }}
                tick={{ fontSize: 12 }}
              />
              <Tooltip
                formatter={(value) => formatCurrencyExtended(value)}
                wrapperStyle={{ background: colors.tooltip }}
                contentStyle={{ borderColor: colors.text, backgroundColor: '#000000' }}
                labelStyle={{ color: colors.text }}
                itemStyle={{ color: colors.text }}
              />
              <Legend
                formatter={(value) => 'Rewards Earned'}
                wrapperStyle={{ color: colors.text }}
              />
              <Bar
                type="monotone"
                dataKey="amountUSD"
                name="Rewards Earned"
                fill={colors.bar}
              >
                <LabelList dataKey="amountUSD" position="top" formatter={formatCurrencyExtended} style={{ fill: colors.text }} />
              </Bar>
            </BarChart>
          </ResponsiveContainer> :
            <LoadingChart />}
          {pendingRewards > 0 && <div style={{ marginTop: '25px' }}>
            Pending Rewards<br />
            <div style={{ marginTop: '5px', width: '100%', justifyContent: 'center', display: 'flex' }}>
              <Button
                onClick={handleClaim}
                rounded
                severity="warning"
                size="small"
                style={{ width: '200px', justifyContent: 'center', }}
              >
                {formatTokenIcon(data.dbData, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E")}
                {formatDecimals(parseFloat(pendingRewards), 9)}
                {' (' + formatCurrencyExtended((pendingRewards / (10 ** 9)) * rocketFiPrice) + ')'}
              </Button>
            </div>
          </div>}
        </Card>}
        {/* <Card
            title={
              earningsSharedData !== undefined
                ? <div style={{ ...infoOutlineStyle, fontSize: '20px' }}>Distributed RocketFi+ Rewards</div>
                : <LoadingChart />
            }
            style={cardOutlineStyle}
          >
            <ResponsiveContainer width="100%" height={200}>
              <BarChart
                data={earningsSharedData}
                margin={{
                  top: 25, right: 5, left: 5, bottom: 5,
                }}
                background={colors.background}
              >
                <XAxis
                  dataKey="date"
                  name="Date"
                  tickFormatter={dateTickFormatter}
                  stroke={colors.text}
                  axisLine={{ stroke: colors.axis }}
                  tickLine={{ stroke: colors.axis }}
                />
                <YAxis
                  dataKey="amountUSD"
                  name="Rewards"
                  tickFormatter={(value) => formatCurrencyExtended(value)}
                  stroke={colors.text}
                  axisLine={{ stroke: colors.axis }}
                  tickLine={{ stroke: colors.axis }}
                />
                <Tooltip
                  formatter={(value) => formatCurrencyExtended(value)}
                  wrapperStyle={{ background: colors.tooltip }}
                  contentStyle={{ borderColor: colors.text, backgroundColor: '#000000'}}
                  labelStyle={{ color: colors.text }}
                  itemStyle={{ color: colors.text }}
                />
                <Legend
                  formatter={(value) => 'RocketFi+ Rewards Generated'}
                  wrapperStyle={{ color: colors.text }}
                />
                <Bar
                  type="monotone"
                  dataKey="amountUSD"
                  name="Rewards Earned"
                  fill={colors.bar}
                >
                  <LabelList dataKey="amountUSD" position="top" formatter={formatCurrencyExtended} style={{ fill: colors.text }} />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </Card> */}
        {/*the same distributed rocketfi+ rewards bar chart data but in Line Chart */}
        <Card
          title={
            <div style={{ ...infoOutlineStyle, fontSize: '16px' }}>Distributed RocketFi+ Rewards</div>
          }
          style={cardOutlineStyle}
        >
          {earningsSharedData ? //take up the entire height of the container
            <ResponsiveContainer width="100%" height={300}
            >
              <LineChart
                data={earningsSharedData}
                margin={{
                  top: 25, right: 5, left: -15, bottom: 5,
                }}
                background={colors.background}
              >
                <XAxis
                  dataKey="date"
                  name="Date"
                  tickFormatter={dateTickFormatter}
                  stroke={colors.text}
                  axisLine={{ stroke: colors.axis }}
                  tickLine={{ stroke: colors.axis }}
                  tick={{ fontSize: 12 }}
                />
                <YAxis
                  dataKey="amountUSD"
                  name="Rewards"
                  tickFormatter={(value) => formatCurrencyExtended(value)}
                  stroke={colors.text}
                  axisLine={{ stroke: colors.axis }}
                  tickLine={{ stroke: colors.axis }}
                  tick={{ fontSize: 12 }}
                />
                <Tooltip
                  formatter={(value) => formatCurrencyExtended(value)}
                  wrapperStyle={{ background: colors.tooltip }}
                  contentStyle={{ borderColor: colors.text, backgroundColor: '#000000' }}
                  labelStyle={{ color: colors.text }}
                  itemStyle={{ color: colors.text }}
                />
                <Legend
                  formatter={(value) => 'RocketFi+ Rewards Generated'}
                  wrapperStyle={{ color: colors.text }}
                />
                <Line
                  type="monotone"
                  dataKey="amountUSD"
                  name="Rewards Distributed"
                  stroke={colors.bar}
                >
                  {/* <LabelList dataKey="amountUSD" position="top" formatter={formatCurrencyExtended} style={{ fill: colors.text }} /> */}
                </Line>
              </LineChart>
            </ResponsiveContainer> :
            <LoadingChart />}
        </Card>

      </div>
    );
  });
 
  const handleTimeRangeChange = useCallback((event) => {
    setSelectedTimeRange(event.target.value);
}, []);

  const ChangeSmartCodeComponent = React.memo(() => {
    return (

      <>
        <div style={infoOutlineStyle}>
          {/*console.log("TESTER:",smartCodeData.smartCode)*/}
          {smartCodeData.smartCode}
        </div>
        <div

          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
            gap: '10px',
            marginTop: '10px',
            marginBottom: '10px'
          }}
        >
          <div>

            {//(smartCodeData?.stats?.totalPurchases > 0 || smartCodeData?.stats?.totalReferrals > 0 || smartCodeData?.stats?.amountBought > 0) &&
              <>

                <SmartCodeLoyaltyProgressComponent />

                {/* {//rocketFiRewardsData?.shares > 0 && rocketFiLoyaltyPoints > 0 &&
                <div style={{ ...cardHeaderStyle, marginTop: "20px" }}>

                  SmartCode Swapper: <div style={{ overflowWrap: "break-word" }}>{smartCodeSwapper}</div>
                  <br />
                 
                </div>

              } */}
              </>
            }

            {!inMigration && <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', marginTop: '10px' }}>
              <Button
                label="Change Smart Code"

                rounded
                severity="primary"
                size="small"
                style={{ width: '100%', justifyContent: 'center' }}
              />
            </div>}
          </div>

          <RewardChartComponent />



        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
          gap: '10px',
          marginTop: '10px',
          marginBottom: '10px'
        }}>
          <div>
            <div style={{
              ...miniInfoStyle, marginTop: '15px', marginBottom: '10px',
              textAlign: 'center', fontSize: '16px', fontWeight: 'bold'
            }}>
              Last Swap Referrals (30 Days)
            </div>
            <Table
              aria-label="Last 10 Swap Referrals"
              css={{
                height: "auto",
                minWidth: "100%",
                backgroundColor: "white",
              }}>
              <Table.Header>
                <Table.Column>Buyer</Table.Column>
                <Table.Column>Amount</Table.Column>
                <Table.Column>SmartCode Used</Table.Column>
                <Table.Column>Date</Table.Column>
              </Table.Header>
              <Table.Body>
                {smartCodeSwapEventsWithTimestamps
                  .map((event, index) => (
                    <Table.Row key={index}
                    >
                      <Table.Cell><div style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                      }}>
                        {swapSmartCodes && swapSmartCodes[event.returnValues.buyer]?.smartCode !== '' ? swapSmartCodes[event.returnValues.buyer]?.smartCode : formatWalletAddress(event.returnValues.buyer)}
                        {/* { <Button icon="pi pi-copy" size="small" text rounded onClick={() => {
                                                            navigator.clipboard.writeText(swapSmartCodes[event.returnValues.buyer]?.smartCode !== '' ? swapSmartCodes[event.returnValues.buyer]?.smartCode : event.returnValues.buyer);
                                                            toast.current.show({
                                                                severity: 'success',
                                                                summary: 'Copied to clipboard',
                                                                detail: swapSmartCodes[event.returnValues.buyer]?.smartCode !== '' ? swapSmartCodes[event.returnValues.buyer]?.smartCode : event.returnValues.buyer, //event.returnValues.buyer,
                                                                life: 3000
                                                            });
                                                        }}
                                                            style={{
                                                                padding: '0px 5px 0px 5px',
                                                                margins: '0px',
                                                            }}
                                                            //label={formatWalletAddress(event.returnValues.buyer)}
                                                            severity="secondary"
                                                        /> } */}
                      </div></Table.Cell>
                      <Table.Cell><div style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                      }}>
                        {formatDecimals(event.returnValues.amountBoughtPreFee, 9)} / <em>{formatCurrencyExtended((event.returnValues.amountBoughtPreFee / (10 ** 9)) * rocketFiPrice)}</em>
                      </div>
                      </Table.Cell>
                      <Table.Cell><div style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                      }}>
                        {event.returnValues.smartCode}
                      </div>
                      </Table.Cell>
                      <Table.Cell>
                        <div style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                        }}>
                          {new Date(event.timestamp * 1000).toLocaleString()}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
              {smartCodeSwapEventsWithTimestamps.length > 10 && <Table.Pagination
                shadow
                noMargin
                align="center"
                rowsPerPage={10}
                onPageChange={(page) => console.log({ page })}
              />}
            </Table>
          </div>
          {/* <select value={selectedTimeRange} onChange={handleTimeRangeChange}
            style={{
              borderRadius: '20px',
              padding: '5px',
              textColor: 'white',
              fontWeight: 'bold',
            }}
          >
            <option value="7d">Last 7 days</option>
            <option value="30d">Last 30 days</option>
            <option value="3m">Last 3 months</option>
            <option value="6m">Last 6 months</option>
            <option value="9m">Last 9 months</option>
            <option value="1y">Last 1 year</option>
            <option value="all">All</option>
          </select> */}
          {smartCodeReferralEventsWithTimestamps?.length > 0 && <div>
            <div style={{
              ...miniInfoStyle, marginTop: '15px', marginBottom: '10px',
              textAlign: 'center', fontSize: '16px', fontWeight: 'bold'
            }}>
              Your Recent Referrals
            </div>
            <Table
              aria-label="Last 10 Swap Referrals"
              css={{
                height: "auto",
                minWidth: "100%",
                backgroundColor: "white",
              }}>
              <Table.Header>
                <Table.Column>Buyer</Table.Column>
                <Table.Column>Amount</Table.Column>
                <Table.Column>Date</Table.Column>
              </Table.Header>
              <Table.Body>
                {smartCodeReferralEventsWithTimestamps?.map((event, index) => (
                  <Table.Row key={index}
                  >
                    <Table.Cell><div style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                    }}>
                      {referralSmartCodes && referralSmartCodes[event.returnValues.buyer]?.smartCode !== '' ? referralSmartCodes[event.returnValues.buyer]?.smartCode : formatWalletAddress(event.returnValues.buyer)}
                      {/* {formatWalletAddress(event.returnValues.buyer)} */}
                    </div></Table.Cell>
                    <Table.Cell><div style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                    }}>
                      {formatDecimals(event.returnValues.amountBoughtPreFee, 9)} / <em>{formatCurrencyExtended((event.returnValues.amountBoughtPreFee / (10 ** 9)) * rocketFiPrice)}</em>
                    </div>
                    </Table.Cell>
                    <Table.Cell>
                      <div style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                      }}>
                        {new Date(event.timestamp * 1000).toLocaleString()}
                      </div>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>

          </div>}

          <div>
            <div style={{
              ...miniInfoStyle, marginTop: '15px', marginBottom: '10px',
              textAlign: 'center', fontSize: '16px', fontWeight: 'bold'
            }}>
              Recently Created Smart Codes
            </div>
            <Table
              aria-label="Last 10 Swap Referrals"
              css={{
                height: "auto",
                minWidth: "100%",
                backgroundColor: "white",
              }}>
              <Table.Header>
                <Table.Column>Address</Table.Column>
                <Table.Column>SmartCode</Table.Column>
                <Table.Column>Date</Table.Column>
              </Table.Header>
              <Table.Body>
                {smartCodeCreationEventsWithTimestamps?.sort((a, b) => b.blockNumber - a.blockNumber)
                  .map((event, index) => (
                    <Table.Row key={index}
                    >
                      <Table.Cell><div style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                      }}>
                        {formatWalletAddress(event.returnValues.holder)}
                      </div></Table.Cell>
                      <Table.Cell><div style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                      }}>
                        {event.returnValues.smartCode}
                      </div>
                      </Table.Cell>
                      <Table.Cell>
                        <div style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                        }}>
                          {new Date(event.timestamp * 1000).toLocaleString()}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
              {smartCodeCreationEventsWithTimestamps.length > 10 && <Table.Pagination
                shadow
                noMargin
                align="center"
                rowsPerPage={10}
                onPageChange={(page) => console.log({ page })}
              />}
            </Table>
          </div>
        </div>
      </>
    );
  });


  //useEffects
  useEffect(() => {
    if (!isWalletConnected()) return;

    try {
      const storedEarningsData = localStorage.getItem(`earningsData-${account}`);
      const storedEarningsSharedData = localStorage.getItem(`earningsSharedData-${account}`);

      if (storedEarningsData && storedEarningsData !== "undefined") {
        setEarningsData(JSON.parse(storedEarningsData));
      }
      if (storedEarningsSharedData && storedEarningsSharedData !== "undefined") {
        setEarningsSharedData(JSON.parse(storedEarningsSharedData));
      }
    } catch (error) {
      console.error("Error reading from local storage:", error);
      // Optionally reset the state or handle the error further
    }

  }, [account]);



  useEffect(() => {
    // Save the earningsData and earningsSharedData to localStorage
    saveEarningsDataToLocal(earningsData, `earningsData-${account}`);
    saveEarningsDataToLocal(earningsSharedData, `earningsSharedData-${account}`);
  }, [earningsData, earningsSharedData, account]);

  useEffect(() => {
    if (smartCodeInputRef.current) {
      smartCodeInputRef.current.focus();
    }
  }, [smartCode]);

  const initialLoad = useRef(true);

  useEffect(() => {
    const fetchSmartCodeData = async () => {
      const result = await getSmartCodeData();
      setSmartCodeData(result);
      const result2 = await getLoyaltyPoints();
      setRocketFiLoyaltyPoints(result2);
      const result3 = await getCumulativeLoyaltyPointsAllHolders();
      setCumulativeLoyaltyPoints(result3);
      const result4 = await getRocketFiRewardsData();
      setRocketFiRewardsData(result4);
      const result5 = await getPendingRewards();
      setPendingRewards(result5);
      const result6 = await getSmartCodeSwapperAddress();
      setSmartCodeSwapper(result6);
      const result7 = await getWeights();
      //console.log("getWeights:", result7);
      setLoyaltyEngineData(result7);
      const result8 = await getEarningsTrackerData("0x6e61579c22F9a6dA63a33e819f29B6697d2a126E");
      //console.log("getEarningsTrackerData:", result8);
      setEarningsData(result8);
      const result9 = await getEarningsSharedTrackerData("0x6e61579c22F9a6dA63a33e819f29B6697d2a126E");
      //console.log("getSharedEarningsTrackerData:", result9);
      setEarningsSharedData(result9);
    };

    if (data && contracts.smartCodes && contracts.smartCodePositionOracle && contracts.rocketFiRewards && contracts.earningsTracker) {
      fetchSmartCodeData();
    }
    // After the initial load
    if (initialLoad.current) {
      initialLoad.current = false;
    } else {
      // re-fetch the earningsSharedData
      getEarningsSharedTrackerData("0x6e61579c22F9a6dA63a33e819f29B6697d2a126E").then(data => {
        // Compare with the cached data and update the state if different.
        // This will cause the component to re-render with the updated data.
        if (JSON.stringify(data) !== JSON.stringify(earningsSharedData)) {
          setEarningsSharedData(data);
        }
      });
    }
  }, [data, contracts]);


  //web3 handles
  const handleCreateSmartCode = async (smartCode) => {
    if (!isWalletConnected()) {
      return;
    }
    if (!contracts.smartCodes) {
      return;
    }

    console.log("Smart Codes: Create button clicked");

    try {
      const transaction = contracts.smartCodes.methods.registerSmartCode(smartCode).send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });


    } catch (error) {
      console.error("Error interacting with the Smart Code contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Smart Code contract: ${error.message}`, life: 3000 });
    }
    getData();
  };

  const handleResyncPoints = async () => {
    if (!isWalletConnected()) {
      return;
    }
    if (!contracts.smartCodeRewardShareSyncer) {
      return;
    }

    console.log("Smart Codes Point Resync: Resync button clicked");

    try {
      const transaction = contracts.smartCodeRewardShareSyncer.methods.syncShares().send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

    } catch (error) {
      console.error("Error interacting with the Smart Codes Point Resync contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Smart Codes Point Resync contract: ${error.message}`, life: 3000 });
    }
    getData();
  };

  const handleChangeSmartCode = async (smartCode) => {
    if (!isWalletConnected()) {
      return;
    }
    if (!contracts.smartCodes) {
      return;
    }

    console.log("Smart Codes: Change code button clicked");

    try {
      const transaction = contracts.smartCodes.methods.changeSmartCode(smartCode).send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

    } catch (error) {
      console.error("Error interacting with the Smart Code contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Smart Code contract: ${error.message}`, life: 3000 });
    }
    getData();
  };

  const handleMigrateSmartCode = async (smartCode) => {
    if (!isWalletConnected()) {
      return;
    }
    if (!contracts.smartCodes) {
      return;
    }

    console.log("Smart Codes: Migrate button clicked");

    try {
      const transaction = contracts.smartCodes.methods.migrate().send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

    } catch (error) {
      console.error("Error interacting with the Smart Code contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Smart Code contract: ${error.message}`, life: 3000 });
    }
    getData();
  };

  const handleClaim = async () => {
    //console.log("SmartCode Rewards: Claim Rewards button clicked - rocketfiRewards:", rocketfiRewards);
    //console.log("SmartCode Rewards: Claim Rewards button clicked - token:", token);

    if (!isWalletConnected()) {
      console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }
    if (!contracts.rocketFiRewards) {
      return;
    }
    const rocketFiRewards = contracts.rocketFiRewards;
    if (!rocketFiRewards) {
      console.error("SmartCode Rewards contract not available.");
      return;
    }

    console.log("SmartCode Rewards: Claim Rewards button clicked");

    try {
      const transaction = rocketFiRewards.methods.claimDividends("0x6e61579c22F9a6dA63a33e819f29B6697d2a126E").send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });


    } catch (error) {
      console.error("Error interacting with the SmartCode Rewards contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the SmartCode Rewards contract: ${error.message}`, life: 3000 });
    }
    getData();
  };


  //web3 calls
  const getIsMigrated = useCallback(async () => {
    const result = await contracts.smartCodes.methods.isMigrated(account).call();
    //console.log("getIsMigrated:", result);
    return result;
  }, [contracts]);

  const inMigration = useCallback(async () => {
    const result = await contracts.smartCodes.methods.inMigration().call();
    //console.log("inMigration:", result);
    return result;
  }, [contracts]);

  const getIsRegistered = useCallback(async (smartCode) => {
    const result = await contracts.smartCodes.methods.checkIsRegistered(smartCode).call();
    //console.log("getIsRegistered for", smartCode, ":", result);
    return result;
  }, [contracts]);

  const getIsRegisteredFull = useCallback(async (smartCode) => {
    const result = await contracts.smartCodes.methods.checkIsRegisteredFull(smartCode).call();
    //console.log("getIsRegisteredFull for", smartCode, ":", result);
    return result;
  }, [contracts]);

  const getSmartCodeData = useCallback(async () => {
    const result = await contracts.smartCodes.methods.smartCodeData(account).call();
    //console.log("getSmartCodeData:", result);
    return result;
  }, [contracts]);

  const getSmartCodeDataUser = useCallback(async (user) => {
    const result = await contracts.smartCodes.methods.smartCodeData(user).call();
    //console.log("getSmartCodeData:", result);
    return result;
  }, [contracts]);

  const getLoyaltyPoints = useCallback(async () => {
    const result = await contracts.smartCodes.methods.getLoyaltyPoints(account).call();
    //console.log("getLoyaltyPoints:", result);
    return result;
  }, [contracts]);

  const getCumulativeLoyaltyPointsAllHolders = useCallback(async () => {
    const result = await contracts.smartCodePositionOracle.methods.getCumulativeLoyaltyPointsAllHolders().call();
    //console.log("getCumulativeLoyaltyPointsAllHolders:", result);
    return result;
  }, [contracts]);

  const getRocketFiRewardsData = useCallback(async () => {
    const result = await contracts.rocketFiRewards.methods.shareholders(account).call();
    //console.log("getRocketFiRewardsData:", result);
    return result;
  }, [contracts]);

  const getPendingRewards = useCallback(async () => {
    const result = await contracts.rocketFiRewards.methods.getTotalUnrealisedWithRealisedUndeposited(account, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E").call();
    //console.log("getPendingRewards:", result);
    return result;
  }, [contracts]);

  const getSmartCodeSwapperAddress = async () => {
    const result = await contracts.smartCodes.methods.ownerToProxy(account).call();
    //console.log("getSwapper:", result);
    return result;
  }

  // earnings tracker calls

  const getEarningsTrackerData = useCallback(async (token) => {
    const index = await contracts.earningsTrackerV1.methods.getIndexOfEarnings(contracts.smartCodesV1._address, account, token).call();
    const rawData = [];
    for (let i = 0; i < index; i++) {
      const data = await contracts.earningsTrackerV1.methods.getEarnings(contracts.smartCodesV1._address, account, token, i).call();

      const date = new Date(data.timestamp * 1000).toLocaleDateString();
      rawData.push({
        ...data,
        amount: parseFloat(data.amount) / 10 ** 9,
        amountUSD: parseFloat(data.amount) / 10 ** 9 * rocketFiPrice,
        timestamp: parseFloat(data.timestamp),
        totalCumulativeEarnings: parseFloat(data.totalCumulativeEarnings),
        date: date
      });
    }

    const index2 = await contracts.earningsTracker.methods.getIndexOfEarnings(contracts.smartCodes._address, account, token).call();
    for (let i = 0; i < index2; i++) {
      const data = await contracts.earningsTracker.methods.getEarnings(contracts.smartCodes._address, account, token, i).call();

      const date = new Date(data.timestamp * 1000).toLocaleDateString();
      rawData.push({
        ...data,
        amount: parseFloat(data.amount) / 10 ** 9,
        amountUSD: parseFloat(data.amount) / 10 ** 9 * rocketFiPrice,
        timestamp: parseFloat(data.timestamp),
        totalCumulativeEarnings: parseFloat(data.totalCumulativeEarnings),
        date: date
      });
    }

    const uniqueDates = [...new Set(rawData.map(item => item.date))];

    const aggregatedData = uniqueDates.map(date => {
      const filteredData = rawData.filter(item => item.date === date);
      const sumAmount = filteredData.reduce((acc, curr) => acc + curr.amount, 0);
      const sumAmountUSD = filteredData.reduce((acc, curr) => acc + curr.amountUSD, 0);
      return {
        ...filteredData[0],  // take the first object to get other fields
        amount: sumAmount,  // replace the amount with the aggregated sum
        amountUSD: sumAmountUSD  // replace the amount with the aggregated sum
      };
    });

    return aggregatedData;
  }, [contracts, rocketFiPrice]);

  const getEarningsSharedTrackerData = useCallback(async (token) => {
    const index = await contracts.earningsTracker.methods.getIndexOfEarnings(contracts.smartCodes._address, contracts.rocketFiRewards._address, token).call();
    const rawData = [];
    for (let i = 0; i < index; i++) {
      const data = await contracts.earningsTracker.methods.getEarnings(contracts.smartCodes._address, contracts.rocketFiRewards._address, token, i).call();

      const date = new Date(data.timestamp * 1000).toLocaleDateString();
      rawData.push({
        ...data,
        amount: parseFloat(data.amount) / 10 ** 9,
        amountUSD: parseFloat(data.amount) / 10 ** 9 * rocketFiPrice,
        timestamp: parseFloat(data.timestamp),
        totalCumulativeEarnings: parseFloat(data.totalCumulativeEarnings),
        date: date
      });
    }

    const uniqueDates = [...new Set(rawData.map(item => item.date))];

    const aggregatedData = uniqueDates.map(date => {
      const filteredData = rawData.filter(item => item.date === date);
      const sumAmount = filteredData.reduce((acc, curr) => acc + curr.amount, 0);
      const sumAmountUSD = filteredData.reduce((acc, curr) => acc + curr.amountUSD, 0);
      return {
        ...filteredData[0],  // take the first object to get other fields
        amount: sumAmount,  // replace the amount with the aggregated sum
        amountUSD: sumAmountUSD  // replace the amount with the aggregated sum
      };
    });

    return aggregatedData;
  }, [contracts, rocketFiPrice]);

  // loyalty engine calls

  const getWeights = useCallback(async () => {
    const w1 = await contracts.loyaltyEngine.methods.w1().call();
    const w2 = await contracts.loyaltyEngine.methods.w2().call();
    const w3 = await contracts.loyaltyEngine.methods.w3().call();
    const w4 = await contracts.loyaltyEngine.methods.w4().call();
    const w5 = await contracts.loyaltyEngine.methods.w5().call();
    const w6 = await contracts.loyaltyEngine.methods.w6().call();
    const TIME_MULTIPLIER = await contracts.loyaltyEngine.methods.TIME_MULTIPLIER().call();
    const PURCHASE_MULTIPLIER = await contracts.loyaltyEngine.methods.PURCHASE_MULTIPLIER().call();
    const TOKEN_MULTIPLIER = await contracts.loyaltyEngine.methods.TOKEN_MULTIPLIER().call();
    const REFERRAL_MULTIPLIER = await contracts.loyaltyEngine.methods.REFERRAL_MULTIPLIER().call();
    const BURN_MULTIPLIER = await contracts.loyaltyEngine.methods.BURN_MULTIPLIER().call();
    const WALLET_MULTIPLIER = await contracts.loyaltyEngine.methods.WALLET_MULTIPLIER().call();
    const result = { w1, w2, w3, w4, w5, w6, TIME_MULTIPLIER, PURCHASE_MULTIPLIER, TOKEN_MULTIPLIER, REFERRAL_MULTIPLIER, BURN_MULTIPLIER, WALLET_MULTIPLIER };
    //console.log("getWeights:", result);
    return result;
  }, [contracts]);



  return (
    <Card title={
      data?.contractData?.forgeData?.referralCode !== undefined
        ? <div style={cardHeaderStyle}>Smart Code</div>
        : <Skeleton width="70%" height="25px" className="mb-2" />
    }
      style={{
        ...cardOutlineStyle,
        border: 'none',
        // gridColumn: "span 2",
        // gridRow: "span 1",
      }}>

      <div
      //style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '10px', marginTop: '10px' }}
      >
        {smartCodeData?.smartCode === "" && !data?.contractData?.forgeData?.referralCode
          ? <CreateSmartCodeComponent />
          : data?.contractData?.forgeData?.referralCode && smartCodeData?.smartCode === ""
            ? <MigrateSmartCodeComponent />
            : smartCodeData?.smartCode
              ? <ChangeSmartCodeComponent />
              : <Skeleton width="100%" height="35px" className="mb-2" />
        }

      </div>
      <Toast ref={toast} />
    </Card>
  );
}

export default React.memo(DashboardSmartCode);


function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};


function roundDown(number, decimals) {
  decimals = decimals || 0;
  return (Math.floor(number * Math.pow(10, decimals)) / Math.pow(10, decimals));
}

function roundDownBig(bigNumberValue, decimals = 0) {
  const factor = new BigNumber(10).pow(decimals);
  return bigNumberValue.times(factor).integerValue(BigNumber.ROUND_DOWN).dividedBy(factor).toNumber();
}